import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { selectIsCollapsed } from '@core/state/userProfile/userProfile.selectors';
import { Store } from '@ngrx/store';
import { filter, map, mergeMap, startWith, Subject, takeUntil } from 'rxjs';
import { HeaderComponent } from '../../../components/header/header.component';
import { ImpersonationBannerComponent } from '../../../shared/components/impersonation-banner/impersonation-banner.component';

@Component({
    selector: 'au-auth-layout',
    templateUrl: './auth-layout.component.html',
    styleUrls: ['./auth-layout.component.scss'],
    imports: [ImpersonationBannerComponent, HeaderComponent, RouterOutlet]
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
  isCollapsed = false;
  isWhiteBackground: boolean = false;
  destroyed$: Subject<void> = new Subject();

  constructor(
    private store: Store<any>,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.store.select(selectIsCollapsed).subscribe((isCollapsed) => {
      this.isCollapsed = isCollapsed;
    });
  }

  ngOnInit() {
    this.routerEvents();
  }

  routerEvents(): void {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        startWith(this.router),
        map(() => this.route),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        mergeMap((route) => route.data),
        takeUntil(this.destroyed$)
      )
      .subscribe(({ isWhiteBackground }) => {
        this.isWhiteBackground = isWhiteBackground;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.unsubscribe();
  }
}
